const ar = {
  // Navbar
  nav_home: "الرئيسية",
  nav_about: "عن العم تنتن",
  nav_services: "الخدمات والأسعار",
  nav_flow: "سير الخدمة",
  nav_testimonials: "آراء العملاء",
  nav_faq: "الأسئلة الشائعة",
  nav_contact: "تواصل معنا",
  nav_cta: "احجز قراءة الاسم",
  nav_subtitle: "قراءة الأسماء · أوكيناوا",
  nav_title: "مكتب العم تنتن",

  // Hero
  hero_headline1: "في جزيرة",
  hero_headline2: "أوكيناوا الهادئة،",
  hero_headline3: "نستمع",
  hero_headline4: "إلى صوت اسمك.",
  hero_body: "حجوزات قراءة الأسماء تمتد لأشهر من الانتظار.\nكل شهر أزور جزيرة أوكيناوا شخصياً\nلأنقل اسمك إلى الأستاذ.",
  hero_pill1: "بدون تغيير الاسم",
  hero_pill2: "100% عبر الإنترنت",
  hero_pill3: "التسليم خلال شهر",
  hero_pill4: "100 مقعد شهرياً",
  hero_btn_apply: "احجز قراءة الاسم",
  hero_btn_services: "عرض الخدمات",
  hero_scroll: "مرر للأسفل",

  // About
  about_heading: "عن العم تنتن",
  about_intro: "في جزيرة <strong>إيكي</strong> الهادئة، المحاطة ببحر أوكيناوا الدافئ،\nيعيش شخص يضيف ضوءاً صغيراً لكل اسم.\nيناديه الناس بمحبة <strong>\"العم تنتن\"</strong>.",
  about_block1_label: "من موظف بنك إلى قارئ أسماء",
  about_block1_text: "كان العم تنتن في الأصل موظفاً في بنك.\nبتفانٍ، أصبح <strong>أصغر مدير فرع</strong> في الشركة.\nعند لقائه بكثير من الناس، نشأ في قلبه تساؤل.",
  about_block1_quote: "\"لماذا يبدو بعض الناس وكأنهم يبحرون مع الريح المواتية، حتى مع نفس الجهد؟\"",
  about_block1_sub: "هذا التساؤل الصغير كان بداية رحلة اكتشاف كبيرة.",
  about_block2_label: "الحكمة القديمة والإضاءة الهادئة",
  about_block2_text: "كرّس كل وقت فراغه لدراسة النصوص القديمة في قراءة الأسماء، مستكشفاً بعناية خطوط الكانجي التقليدية والتدفق الصوتي.",
  about_block2_text2: "أدرك أن <strong>\"نقاط التنتن يمكنها أن تنسّق تدفق الاسم بلطف\"</strong>.",
  about_block2_sub: "ليست سحراً درامياً، ولا وصفة نجاح مذهلة.\nإنه طريق لطيف لإظهار الضوء الموجود بداخلك بشكل أوضح.",
  about_block3_label: "انتشر بالكلام الشفهي — الآن مع 6 أشهر انتظار",
  about_block3_text: "انتشرت قراءته الدافئة تماماً بالكلام الشفهي، والآن <strong>تصله استفسارات من جميع أنحاء البلاد دون توقف</strong>.\nيعامل الجميع بنفس القلب، سواء كانوا مشهورين أم لا.\nيضع يديه على كل اسم ويرافق حياة كل شخص.\nهذه هي طريقة العم تنتن.",

  // Gallery
  gallery_heading: "معرض الصور",
  gallery_sub: "أوكيناوا · جزيرة إيكي",

  // Services
  services_heading: "الخدمات والأسعار",
  services_note1: "※ جميع الخطط تشمل رسوم قراءة الأستاذ ورسوم خدمة التمثيل المحلي.",
  services_note2: "※ لا توجد تكاليف إضافية. يمكنك الثقة بهدوء.",
  services_tab1: "الاسم الشخصي",
  services_tab2: "اسم العمل",
  services_tab3: "اسم الحيوان الأليف",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "نفحص بلطف نموك وبيئتك وحركات قلبك لإضافة نقاط التنتن الأنسب.",
  services_tab2_desc: "نجلب نسيماً لطيفاً للتحديات الجديدة. ننسّق تدفق العمل بهدوء.",
  services_tab3_desc: "لعضو الأسرة الذي يكون دائماً بجانبك. نمنحه اسماً مليئاً بالسلام والدفء.",
  services_row1_target1: "16 سنة فأكثر",
  services_row1_target2: "4 إلى 15 سنة",
  services_row1_target3: "0 إلى 3 سنوات",
  services_row2_target1: "اسم تجاري / شركة / متجر",
  services_row3_target1: "اسم الحيوان الأليف",
  services_col_target: "الفئة المستهدفة",
  services_col_price: "السعر (شامل الضريبة)",
  services_cta: "احجز هذه الخدمة",
  services_includes_title: "ما يشمله السعر (كل شيء مدرج)",
  services_inc1: "قراءة الاسم",
  services_inc2: "اقتراح نقاط التنتن المثالية",
  services_inc3: "إرسال بطاقة بحجم بطاقة العمل (مجاناً إذا رغبت)",
  services_inc4: "نصيحة الحظ السعيد",
  services_inc5: "صورة رقمية لبطاقة الاسم",
  services_includes_note: "تهدف القراءة إلى الكشف بلطف عن السحر الموجود بالفعل في الاسم.",
  services_payment_title: "طريقة الدفع",
  services_payment_method: "تحويل بنكي (مسبق الدفع)",
  services_payment_desc: "بعد التسجيل، سنوفر لك تفاصيل الحساب البنكي.\nعند اكتمال الدفع، يبدأ تدفق الحظ السعيد في التجمع بهدوء.",
  services_first_title: "لمن يزور لأول مرة",
  services_first_desc: "من الطبيعي أن تشعر بعدم اليقين.\nهذا الشعور هو إشارة داخلية،\nبأن الوقت قد حان لبدء تغيير لطيف.",
  services_first_cta: "ابدأ باستشارة",

  // Flow
  flow_heading: "سير الخدمة",
  flow_step1_title: "إرسال النموذج",
  flow_step1_c1: "أدخل المعلومات المطلوبة في النموذج المخصص.",
  flow_step1_c2: "سنرد خلال 2 إلى 3 أيام عمل بعد الإرسال.",
  flow_step1_c3: "سيتضمن البريد الإلكتروني الخطوات التالية وتعليمات التحويل البنكي.",
  flow_step2_title: "تحويل رسوم القراءة",
  flow_step2_c1: "حوّل رسوم القراءة إلى الحساب المحدد في بريد الرد الإلكتروني.",
  flow_step2_c2: "بعد تأكيد الدفع، سنبدأ في تحضير القراءة بالترتيب.",
  flow_step3_title: "إشعار اكتمال التحويل",
  flow_step3_c1: "بعد التحويل، أرسل صورة الإيصال إلى العنوان المحدد في البريد الإلكتروني.",
  flow_step3_c2: "بعد التأكيد، سنرسل رسالة \"اكتمل التسجيل\".",
  flow_step3_note: "بدون هذا الإشعار، لا يمكننا بدء القراءة. يرجى الإرسال حتماً.",
  flow_step4_title: "استلام نتيجة القراءة",
  flow_step4_c1: "بعد اكتمال القراءة، سنرسل بطاقة الاسم وصورة نقاط التنتن عبر البريد الإلكتروني في غضون أسبوع تقريباً.",
  flow_step4_c2: "ثم سنرسل تقرير القراءة التفصيلي ونصيحة الحظ السعيد عبر البريد الإلكتروني.",
  flow_step5_title: "إرسال بطاقة الاسم (اختياري)",
  flow_step5_c1: "إذا رغبت، سنرسل بريدياً بطاقة بحجم بطاقة العمل مكتوبة بخط الأستاذ نفسه.",
  flow_step5_c2: "يرجى إدخال عنوان البريد الصحيح في حقل العنوان في النموذج.",
  flow_step5_note: "إذا لم تكن بحاجة إلى البطاقة، فأدخل فقط مدينة إقامتك.",
  flow_banner_title: "كل شيء عبر الإنترنت. من أي مكان في اليابان.",
  flow_banner_desc: "لا داعي للمجيء شخصياً إلى جزيرة إيكي في أوكيناوا.\nيمكنك البدء فوراً دون تغيير روتينك اليومي.",
  flow_banner_cta: "سجّل الآن",

  // Testimonials
  testimonials_heading: "آراء العملاء",
  testimonials_viewing: "جارٍ العرض",

  // FAQ
  faq_heading: "الأسئلة الشائعة",
  faq_cta_title: "هل لديك أسئلة أخرى؟",
  faq_cta_desc: "أي سؤال صغير مرحب به.\nالأسئلة التي تخجل من طرحها — هي بالضبط ما نريد سماعه أكثر.",
  faq_cta_btn: "اطرح سؤالاً",

  // CTA Banner
  cta_heading1: "استشارة",
  cta_heading2: "مجانية",
  cta_btn: "احجز الآن",

  // Contact
  contact_heading: "تواصل معنا",
  contact_desc: "أرسل طلب القراءة أو استفسارك من خلال هذا النموذج. عادةً ما نرد خلال 2 إلى 3 أيام عمل.",
  contact_address_label: "العنوان",
  contact_address_value: "توتشيغي، اليابان (عبر الإنترنت · خدمة وطنية)",
  contact_email_label: "البريد الإلكتروني",
  contact_hours_label: "ساعات العمل",
  contact_hours_value: "الاثنين–الجمعة 9:00–18:00 (مغلق السبت/الأحد/العطل)",
  contact_note_title: "حول الردود",
  contact_note_desc: "قد تذهب الردود إلى مجلد البريد العشوائي.\nإذا لم تتلقَّ رداً خلال 2 إلى 3 أيام عمل، تواصل مباشرة عبر البريد الإلكتروني.",
  contact_field_name: "الاسم",
  contact_field_furigana: "فوريغانا (قراءة الاسم)",
  contact_field_email: "عنوان البريد الإلكتروني",
  contact_field_phone: "رقم الهاتف",
  contact_field_service: "الخدمة المطلوبة",
  contact_field_message: "الرسالة",
  contact_placeholder_name: "محمد أحمد",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+966 000 000 0000",
  contact_placeholder_message: "يرجى إدخال الاسم الذي تريد قراءته أو أسئلتك وطلباتك.",
  contact_select_placeholder: "اختر",
  contact_service1: "الاسم الشخصي",
  contact_service2: "اسم العمل",
  contact_service3: "اسم الحيوان الأليف",
  contact_service4: "أخرى / استفسار",
  contact_submit: "إرسال",
  contact_submitting: "جارٍ الإرسال...",
  contact_privacy: "ستُستخدم المعلومات الشخصية المرسلة عبر النموذج فقط لخدمة قراءة الأسماء.",
  contact_error: "فشل الإرسال. حاول مرة أخرى لاحقاً أو تواصل مباشرة عبر البريد الإلكتروني.",
  contact_err_name: "يرجى إدخال اسمك",
  contact_err_email_required: "يرجى إدخال عنوان بريدك الإلكتروني",
  contact_err_email_invalid: "يرجى إدخال عنوان بريد إلكتروني صحيح",
  contact_err_service: "يرجى اختيار خدمة",
  contact_err_message_required: "يرجى إدخال رسالة",
  contact_err_message_limit: "يجب ألا تتجاوز الرسالة 500 حرف",
  contact_thanks_title: "تم إرسال الرسالة",
  contact_thanks_desc: "شكراً لتواصلك معنا.\nبعد مراجعة رسالتك، سنرد خلال <strong>2 إلى 3 أيام عمل</strong>.\nيرجى الانتظار.",
  contact_thanks_check1: "تحقق من بريد التأكيد الإلكتروني",
  contact_thanks_check2: "تحقق أيضاً من مجلد البريد العشوائي",
  contact_thanks_check3: "انتظر الرد خلال 2 إلى 3 أيام عمل",
  contact_thanks_another: "إرسال رسالة أخرى",

  // Footer
  footer_subtitle: "قراءة الأسماء · أوكيناوا",
  footer_title: "مكتب العم تنتن",
  footer_desc: "من أوكيناوا إلى جميع أنحاء البلاد. أستاذ قراءة أسماء بخبرة تزيد على 50 عاماً يقرأ بعناية القدر الكامن في اسمك.",
  footer_contact_title: "معلومات التواصل",
  footer_address_label: "العنوان",
  footer_address_value: "توتشيغي، اليابان\n(عبر الإنترنت · خدمة وطنية)",
  footer_email_label: "البريد الإلكتروني",
  footer_hours_label: "ساعات العمل",
  footer_hours_value: "الاثنين–الجمعة 9:00–18:00\n(مغلق السبت/الأحد/العطل)",
  footer_nav_title: "التنقل",
  footer_copyright: "© 2025 مكتب العم تنتن. جميع الحقوق محفوظة.",
  footer_privacy: "سياسة الخصوصية",
  footer_law: "قانون التجارة المحددة",
  footer_sitemap: "خريطة الموقع",
};

export default ar;
